import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { memo } from 'react';

import { PointOfSale } from '../../../../interface';
import { MultiStoreCardFrame } from './multi-store-card-frame';
import { MultiStoreCenterContent } from './multi-store-center-content';

interface MultiStoreOriginCardProps {
  pointOfSale: PointOfSale;
}

// Prima scheda del pannello: il centro di partenza, sempre incluso e non deselezionabile,
// quindi una scheda statica con la spunta e il badge «Il tuo centro»
export const MultiStoreOriginCard = memo(function MultiStoreOriginCard({
  pointOfSale,
}: MultiStoreOriginCardProps): JSX.Element {
  return (
    <div
      role="checkbox"
      aria-checked="true"
      aria-disabled="true"
      className="multi-store-static-card"
    >
      <MultiStoreCardFrame>
        <MultiStoreCenterContent
          pointOfSale={pointOfSale}
          isOrigin
          adornment={<CheckCircleIcon color="primary" />}
        />
      </MultiStoreCardFrame>
    </div>
  );
});
